import {Table} from 'antd';
import UseSetParams from './filter/UseSetParams';


const TableBox = ({
                      columns, filter,
                      dataRows, rowClassName,
                      totalCount, rowSelection,
                      expandable,
                      loading, getFilter,
                      onDoubleClickRow, rowKey,
                      showSizeChanger = true,
                      showPagination = true,
                  }) => {

    const [,,handleSetPageSizeParams] = UseSetParams(getFilter);
    const funcHandleSetParams = (page,page_size) => {
        handleSetPageSizeParams(page,page_size);
    };


    return <Table rowSelection={rowSelection}
                  rowKey={(record) => record.id || record[rowKey]} onRow={(record) => {
        return {
            onDoubleClick: (f) => {
                // eslint-disable-next-line no-unused-expressions
                onDoubleClickRow && onDoubleClickRow(record, f);
            },

        };
    }}
                  columns={columns}
                  rowClassName={rowClassName}

                dataSource={dataRows} loading={loading} expandable={expandable}
                pagination={showPagination && {
                    total: totalCount, showTotal: (x) => `جمعا  ${x} مورد`,
                    defaultPageSize: 10, pageSize: Number(filter.page_size) || 10,
                    position: ['bottomCenter '],
                    showSizeChanger,

                    onChange: (e = 1, x = 10) => {
                        funcHandleSetParams(e, x)

                    },
                    current: !!filter.page ? Number(filter.page) : 1,
                }} />;
};
export default TableBox;